import { render, staticRenderFns } from "./listreservation.vue?vue&type=template&id=01a10a66&"
import script from "./listreservation.vue?vue&type=script&lang=js&"
export * from "./listreservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports